import { Injectable, inject } from '@angular/core';
import { SessionStore } from '../auth/session.store';

/**
 * Whether a feature flag is on for the signed-in company. Flags come with the session. The
 * API has no flag endpoint yet (P015), so until then every flag is off and the set is empty.
 * Reads a signal, so templates and `computed` values update when the session changes.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly session = inject(SessionStore);

  isOn(flag: string): boolean {
    return this.session.flags().has(flag);
  }
}
